import React from 'react'
import clsx from 'clsx'
import TopBanner from './topBanner/TopBanner'
import { MenuItems } from '../../../enums/MenuItems'
import { PropsWithChildrenRequired } from '../../../types/PropsWithChildrenRequired'
import { Toaster } from 'sonner'

type Props = {
    activeMenuItem: MenuItems
    className?: string
}

export default function LayoutSingleViewFullWidth({
    children,
    activeMenuItem,
    className,
}: PropsWithChildrenRequired<Props>): React.JSX.Element {
    return (
        <div className="h-screen flex flex-col">
            <TopBanner activeMenuItem={activeMenuItem} />
            {/* Main Content Area */}
            <div
                className={clsx(
                    'w-full pt-[4px] pb-[64px] px-8 mx-auto',
                    className,
                )}
            >
                {children}
            </div>
            {/* Global toaster for uiV2 pages */}
            <Toaster richColors />
        </div>
    )
}
